import { useState, useEffect } from "react";
import NotificationSignup from "./NotificationSignup";

export default function NotificationPopup() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if we're in a browser environment
    if (typeof window !== 'undefined') {
      // Check if the user has seen the popup before
      const hasSeenPopup = localStorage.getItem("notificationPopupSeen");

      if (!hasSeenPopup) {
        // Show the popup after a short delay
        const timer = setTimeout(() => {
          setIsVisible(true);
        }, 2000);

        return () => clearTimeout(timer);
      }
    }
  }, []);

  const handleClose = () => {
    // Set localStorage to remember that the user has seen the popup
    localStorage.setItem("notificationPopupSeen", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="max-w-md w-full mx-4 animate-fade-in-up">
        <div className="relative">
          <button
            onClick={handleClose}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <NotificationSignup isPopup={true} onClose={handleClose} />
        </div>
      </div>
    </div>
  );
}

// Add this CSS to your global styles or create a class
// .animate-fade-in-up {
//   animation: fadeInUp 0.3s ease-out;
// }
// 
// @keyframes fadeInUp {
//   from {
//     opacity: 0;
//     transform: translateY(20px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// }
